module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-purchase/land-pur-profession/lp-profession-grid/lp-profession-grid.component.css
// module id = ./src/app/landprocurement/land-purchase/land-pur-profession/lp-profession-grid/lp-profession-grid.component.css
// module chunks = main